var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-screen',{attrs:{"blue":true,"centralised":true}},[_c('div',{staticClass:"locked",domProps:{"innerHTML":_vm._s(_vm.texts.lo.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }